module.exports = __webpack_public_path__ + "assets/img/caught.png?351828aa191b19abb898b492dc0a2cda";